<template>
  <div class="add-student-option">
    <span
      v-for="(option, idx) in options"
      :key="idx"
      :class="`picker-option ${picked === option.input ? 'active' : ''}`"
    >
      <input
        type="radio"
        :id="option.input"
        :value="option.input"
        v-model="vPicked"
        @change="activateOption"
      />
      <i :class="picked === option.input ? option.iconActive : option.icon" />
      <span>{{ option.name }}</span>
    </span>
  </div>
</template>

<script>
  import { always } from 'ramda'
  export default {
    props: {
      options: {
        type: Array,
        default: always([])
      },
      picked: {
        type: String,
      }
    },
    data() {
      return {
        vPicked: this.picked
      }
    },
    methods: {
      activateOption(e) {
        const elementClasses = e.target.parentElement.classList
        if (!elementClasses.contains('active')) {
          const options = document.getElementsByClassName('picker-option')
          for(let option of options) {
            option.classList.remove('active')
          }
          elementClasses.add('active')
        }
      },
    },
    watch: {
      vPicked(newValue) {
        this.$emit('update:picked', newValue)
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../scss/_colors.scss';

  .add-student-option {
    margin-bottom: 44px;
    margin-top: 12px;
    span.picker-option {
      border: 1px solid #E6E6E6;
      box-sizing: border-box;
      border-radius: 8px;
      padding: 12px 16px;
      margin-right: 32px;
      cursor: pointer;
      position: relative;
      font-size: 18px;
      font-weight: 500;
      i {
        display: inline-block;
        vertical-align: middle;
      }
    }
    span.active {
      color: #478DFF;
      border: 1px solid#478DFF;
    }
    input {
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: 111;
      }
  }

</style>
